import { DownloadResource } from '@components/download-resource'
import { RichTextBlock } from '@components/rich-text-block'
import SmallContainer from '@components/ui/layout/SmallContainer'
import { Heading, Text } from '@components/ui/typography'
import { getFileUrl } from '@lib/sanity/get-file-url'
import React, { FC } from 'react'
import { HowItWorksSingleton } from '__generated__/sanity'
import { SectionBottomLine } from '../bottom-line'
import { SectionHeading } from '../section-heading'
import * as styles from './styles'

type TechnicalSpecsProps = HowItWorksSingleton['fields']['technicalSpecs']

export const TechnicalSpecs: FC<TechnicalSpecsProps> = ({
  technicalTitle,
  technicalSpecs,
  technicalSpecsResourcesMainTitle,
  technicalSpecsResources,
}) => {
  return (
    <>
      <SectionHeading title={technicalTitle} />
      <SmallContainer>
        {technicalSpecs.map((item, key) => (
          <div className={styles.specContainer} key={`${item.technicalSpecsMainTitle}-${key}`}>
            <Heading variant="h5" as="h3">
              {item.technicalSpecsMainTitle}
            </Heading>
            <div>
              <Text variant="bodyRegular" className={styles.title}>
                {item.technicalSpecsTitle}
              </Text>
              {item.technicalSpecsContent && (
                <RichTextBlock content={item.technicalSpecsContent} variant="regular" />
              )}
            </div>
          </div>
        ))}
        {technicalSpecsResources && technicalSpecsResources.length > 0 && (
          <div className={styles.specContainer}>
            <Heading variant="h5" as="h3">
              {technicalSpecsResourcesMainTitle}
            </Heading>
            <ul className={styles.downloads}>
              {technicalSpecsResources.map((item, key) => (
                <li key={`${item.technicalSpecsResourceTitle}-${key}`}>
                  <DownloadResource
                    title={item.technicalSpecsResourceTitle}
                    link={getFileUrl(item.technicalSpecsResourceItem.asset._ref)}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}
      </SmallContainer>
      <SectionBottomLine />
    </>
  )
}
